module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"specific_columns":"Specific columns"},"fr":{"specific_columns":"Colonnes spécifiques"}}')
  delete Component.options._Ctor
}
